// import ModalMenuItem from "../../ModalMenu/ModalMenu"
import useStyle from "./useStyle"

function TableItem({ item }) {
  const classes = useStyle()
  const formatDate = (date) => {
    let formattedDate
    if (date) {
      const newDate = new Date(date)
      formattedDate =
        newDate.getDate() +
        '/' +
        (newDate.getMonth() + 1) +
        '/' +
        newDate.getFullYear()
    } else {
      formattedDate = ''
    }
    return formattedDate
  }

  
  return (
    <tr className={classes.row}>
      <td className={classes.name}>{item.subscriptionStatusDesc}</td>
      <td className={classes.name}>{formatDate(item.lastStatusChangeDate)}</td>
      <td className={classes.name}>{item.eventActionUser}</td>
    </tr>
  )
}

export default TableItem
